import styled from '@emotion/styled';
import { FunctionComponent } from 'react';
import { breakpoints, Image } from '@ds/ui';
import breakpointSizes from 'layouts/ApplicationLayout/objects/breakpointSizes/breakpointSizes';
import { CoverImageConstants } from 'layouts/constants';

interface ContainerLayoutCoverProps {
    dataQa?: string;
    imageSource: string;
    imageBackgroundColor?: string;
}

const ImageContainer = styled.div<{
    imageBackgroundColor?: string;
}>`
    background-color: ${({ imageBackgroundColor }) => imageBackgroundColor};
    ${breakpoints.lessThan(breakpointSizes.xs)} {
        height: ${CoverImageConstants.heightMobile};
    }
    ${breakpoints.greaterThan(breakpointSizes.xs)} {
        height: ${CoverImageConstants.heightDesktop};
    }
`;

const ContainerLayoutCover: FunctionComponent<ContainerLayoutCoverProps> = ({ dataQa, imageSource, imageBackgroundColor }) => (
    <ImageContainer imageBackgroundColor={imageBackgroundColor}>
        <Image src={imageSource} data-qa={dataQa || 'layout-cover-ink'} alt={''} objectFit="none" objectPosition="center" />
    </ImageContainer>
);

export default ContainerLayoutCover;
